import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const GOOGLE_PLACE_URL = 'https://www.google.com/maps/place/Fabrikov+s.r.o./@50.9170286,15.0518097,17z/data=!4m8!3m7!1s0x470936a765c5c5a7:0x622f955e26133462!8m2!3d50.9170286!4d15.0518097!9m1!1b1!16s%2Fg%2F1tj7v2kn?hl=cs';

export const GoogleReviewCta = () => {
  const { t } = useLanguage();
  return (
    <section className="pb-4 px-4 sm:px-6 lg:px-8" data-testid="google-review-section">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6 border border-gray-200 dark:border-gray-800 rounded-2xl px-8 py-6 bg-white dark:bg-gray-900">
        <div className="text-center sm:text-left">
          <div className="flex justify-center sm:justify-start gap-1 mb-2 text-amber-400">
            {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={20} fill="currentColor" />)}
          </div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-white">{t('review.title')}</h3>
          <p className="text-gray-600 dark:text-gray-400 text-sm">{t('review.text')}</p>
        </div>
        <a
          href={GOOGLE_PLACE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="google-review-btn"
          className="shrink-0 inline-flex items-center gap-2 bg-white dark:bg-black border-2 border-gray-900 dark:border-white text-gray-900 dark:text-white font-semibold px-6 py-3 rounded-lg hover:bg-gray-900 hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors duration-200"
        >
          <span>{t('review.button')}</span>
          <ExternalLink size={16} />
        </a>
      </div>
    </section>
  );
};
